import type { Starter } from '../Starter'

export const generalStarters: Starter[] = [
  {
    id: 'mind-map',
    name: 'Mind Map',
    description: 'Branching ideas',
    thumbnailUrl: '/assets/images/thumbnails/tb_mindmap.svg',
    translationKey: 'templates.names.mindMap',
    artifact: { kind: 'legacy', templateId: 'No7kRo6W4VC', legacyType: 'diagram/def/mindmap.js#MindMap' },
    job: ['ideate'],
    function: ['general'],
    popular: true,
    curatedBy: 'creately',
  },
  {
    id: 'concept-map',
    name: 'Concept Map',
    description: 'Linked concepts',
    thumbnailUrl: '/assets/images/thumbnails/tb_conceptmap.svg',
    translationKey: 'templates.names.conceptMap',
    artifact: { kind: 'legacy', templateId: 'vAnBkdf0iQR', legacyType: 'diagram/def/concept-map.js#ConceptMap' },
    job: ['ideate'],
    function: ['general'],
    curatedBy: 'creately',
  },
  {
    id: 'brainstorming',
    name: 'Brainstorming',
    description: 'Idea capture',
    thumbnailUrl: '/assets/images/thumbnails/tb_brainstorming.svg',
    translationKey: 'templates.names.brainstorming',
    artifact: { kind: 'legacy', templateId: '5huTIYw7KYR', legacyType: 'diagram/def/block.js#Block' },
    job: ['ideate'],
    function: ['general'],
    popular: true,
    curatedBy: 'creately',
  },
  {
    id: 'meeting-notes',
    name: 'Meeting Notes',
    description: 'Agenda & outcomes',
    thumbnailUrl: '/assets/images/thumbnails/tb_meeting_notes.svg',
    translationKey: 'templates.names.meetingNotes',
    artifact: { kind: 'legacy', templateId: 'CMd4UAmcmQP', legacyType: 'diagram/def/block.js#Block' },
    job: ['document'],
    function: ['general'],
    curatedBy: 'creately',
  },
]
